import { render, staticRenderFns } from "./DeliveryInformation.vue?vue&type=template&id=2a73240c&"
import script from "./DeliveryInformation.vue?vue&type=script&lang=js&"
export * from "./DeliveryInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports